<div class="container" *ngIf="loading">
  <div class="filter-row">
    <div class="filter-div">
      <div class="filter-by animate"></div>
      <div class="ordered-by animate"></div>
      <div class="filters animate"></div>
    </div>
  </div>

  <table class="report-table">
    <thead class="report-table-header">
      <tr>
        <td class="company-name-header">
          <div class="report-checkbox"></div>
          <div class="company-name"></div>
        </td>
        <td class="created-date">
          <div class="created-date-div"></div>
        </td>
        <td class="engaged-date">
          <div class="engaged-date-div"></div>
        </td>
        <td class="due-date">
          <div class="due-date-div"></div>
        </td>
        <td class="state-stage">
          <div class="state-stage-div"></div>
        </td>
        <td class="report-progress">
          <div class="report-progress-div"></div>
        </td>
        <td class="report-contact-info">
          <div class="report-contact-info-div"></div>
        </td>
        <td class="report-options"></td>
      </tr>
    </thead>

    <tbody class="grey-border">
      <tr class="report-table-data" *ngFor="let number of [0,1,2,3,4,5,6,7,8,9]">
        <td class="company-name-data">
          <div class="report-checkbox"></div>
          <div class="company-name"></div>
        </td>
        <td class="created-date-data">
          <div class="created-date-div"></div>
        </td>
        <td class="engaged-date-data">
          <div class="engaged-date-div"></div>
        </td>
        <td class="due-date-data">
          <div class="due-date-div"></div>
        </td>
        <td class="state-stage-data">
          <div class="state-stage-div"></div>
        </td>
        <td class="report-progress-data">
          <div class="report-progress-div"></div>
        </td>
        <td class="report-contact-info-data">
          <div class="data-flex"><div class="report-contact-info-div"></div></div>
        </td>
        <td class="report-options">
          <div class="data-flex"><div class="report-options-div"></div></div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="report-table-pagination">
    <div class="report-table-pagination-div"></div>
  </div>
</div>
